import React from "react";
import { epiPropertyValue } from "@avensia/nitro5-scope-episerver";
import ViewTracker from "Shared/ViewObserver/ViewTracker";
import { promoImpression, promoClick, } from "../../../../../TrackingInformation";
const mapQuickSearchToGa4Promo = (marketingAd) => {
    return {
        promotionId: "block-" + epiPropertyValue(marketingAd.blockId),
        promotionName: epiPropertyValue(marketingAd.blockName),
        creativeName: epiPropertyValue(marketingAd.image),
        locationId: "QuickSearch",
    };
};
export function onClick(event, marketingAd) {
    promoClick(mapQuickSearchToGa4Promo(marketingAd));
}
export default function MarketingAdViewTracker({ children, item }) {
    const onView = (visible, marketingAd) => {
        if (!visible || !!!marketingAd)
            return;
        promoImpression(mapQuickSearchToGa4Promo(marketingAd));
    };
    return (React.createElement(ViewTracker, { key: "autocompleteAdViewTracker", onView: (visible) => onView(visible, item) }, children));
}
